import { StyleSheet, View } from 'react-native'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import ThemedInputSearch from 'components/atoms/ThemedInputSearch'
import _ from 'lodash';
import Button from 'theme/Button'
import ThemedBlock from 'components/atoms/ThemedBlock'
import React from 'react'
import i18n from 'utils/i18n'
import { colorList } from 'utils/colors'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperString from 'utils/helper-string'
import useDeviceSizes from 'utils/deviceSizes/useDeviceSizes';

const ManagementHeader = ({ inputs = [], dragButton = {}, addButton = {} }) => {
	
	const deviceSizes = useDeviceSizes()
	const canShowButton = !_.isEmpty( addButton ) || !_.isEmpty( dragButton )

	return (
		<ThemedBlock
			shadow={ false }
			overflow={ true }
			style={ styles.container }
			transparent>
			
			<View
				style={[ styles.header, deviceSizes.isMobile ? styles.headerMobile : {} ]}>
				
				{ _.size( inputs ) > 0 && (
					<View
						style={ styles.col }>
						
						{ _.map( inputs, (input, inputKey) => {
							return (
								<ThemedInputSearch
									key={ HelperString.hash('management-header', inputKey ) }
									placeholder={ input.placeholder }
									onChangeText={ input.onChangeText }
									style={ [ styles.inputContainer, { marginLeft: inputKey === 0 ? 0 : 10 } ] }
								/>
							);
						})}
					</View>
				)}
				
				{ canShowButton && (
					<View
						style={[ styles.buttonContainer, deviceSizes.isMobile ? styles.buttonContainerMobile : {} ]}>
						
						{ !_.isEmpty( dragButton ) && (
							<>
							<Button
								onPress={ dragButton.onPress }
								style={ styles.button }
								disabled={ dragButton.isSaving === true }
								appearance="ghost"
								icon={ dragButton.drag ?  <Icon icon={ IconSystemConstants.CANCEL } />  : <Icon icon={ IconSystemConstants.MOVE } /> }>
								
								{ _.get( dragButton, 'text', i18n.t( 'management:generic.drag') ) }
							</Button>
							
							{/* The save button */}
							{ (dragButton.drag && dragButton.save !== undefined) && (
								<Button
									onPress={ dragButton.save }
									style={ styles.button }
									isLoading={ dragButton.isSaving === true }
									icon={ <Icon icon={ IconSystemConstants.SAVE } /> }>
									
									{ i18n.t( 'management:form.save') }
								</Button>
							)}
							</>
						)}
						
						{ ((_.isEmpty( dragButton ) || dragButton.drag === false) && !_.isEmpty( addButton ) ) && (
							<Button
								onPress={ addButton.onPress }
								style={ styles.button }
								icon={ <Icon icon={ IconSystemConstants.PLUS } color={ colorList.WHITE.primary } /> }>
								
								{ _.get( addButton, 'text', i18n.t( 'management:generic.add') ) }
							</Button>
						)}
					</View>
				)}
			</View>
		</ThemedBlock>
	)
}

const styles = StyleSheet.create( {
	container: {
		backgroundColor: colorList.DIVIDER.light,
		borderBottomWidth: 2,
		borderBottomColor: colorList.DIVIDER.primary,
		paddingVertical: 4,
		paddingHorizontal: 8
	},

	header: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	headerMobile: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		gap: 5,
	},
	
	inputContainer: {
		justifyContent: 'flex-start',
	},
	
	col: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	
	buttonContainer: {
		flexDirection: 'row',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
	},
	buttonContainerMobile: {
		justifyContent: 'space-evenly',
		width: '100%',
	},
	button: {
		height: 40,
		flex: 1,
	}
});

export default ManagementHeader
